import { Plugins } from '@leverege/plugin';

// import ConsoleExportFormatter from './ConsoleExportFormatter'
// import ConsoleExportFormatterModel from './ConsoleExportFormatterModel'

import CSVExportFormatter from './CSVExportFormatter.js';
import CSVExportFormatterEditor from "./CSVExportFormatterEditor.js";
import CSVExportFormatterModel from './CSVExportFormatterModel.js';
import JSONExportFormatter from './JSONExportFormatter.js';
import JSONExportFormatterEditor from "./JSONExportFormatterEditor.js";
import JSONExportFormatterModel from './JSONExportFormatterModel.js';
export default {
  install: opts => {
    // Plugins.add( 'Model', { type : ConsoleExportFormatterModel.TYPE, model : ConsoleExportFormatterModel } )
    // Plugins.add( 'ModelEditor', { type : ConsoleExportFormatterModel.TYPE, editor : () => null } )
    // Plugins.add( 'ExportFormatter', {
    //   type : ConsoleExportFormatterModel.TYPE,
    //   formatter : ConsoleExportFormatter,
    //   model : ConsoleExportFormatterModel,
    //   name : 'Console'
    // } )

    Plugins.add('Model', {
      type: JSONExportFormatterModel.TYPE,
      model: JSONExportFormatterModel
    });
    Plugins.add('ModelEditor', {
      type: JSONExportFormatterModel.TYPE,
      editor: JSONExportFormatterEditor
    });
    Plugins.add('ExportFormatter', {
      type: JSONExportFormatterModel.TYPE,
      formatter: JSONExportFormatter,
      model: JSONExportFormatterModel,
      name: 'JSON'
    });
    Plugins.add('Model', {
      type: CSVExportFormatterModel.TYPE,
      model: CSVExportFormatterModel
    });
    Plugins.add('ModelEditor', {
      type: CSVExportFormatterModel.TYPE,
      editor: CSVExportFormatterEditor
    });
    Plugins.add('ExportFormatter', {
      type: CSVExportFormatterModel.TYPE,
      formatter: CSVExportFormatter,
      model: CSVExportFormatterModel,
      name: 'CSV'
    });
  }
};